<div class="file-loader-overlay">
  <div class="file-loader-spinner" role="status">
    <span class="spinner-border" aria-hidden="true"></span>
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
